/* ============================================================================
   WWF-CUSTOM FILE | CL-068 | Added 2026-10-18 | Wild + Well-Fed rebrand
   ----------------------------------------------------------------------------
   Course affiliate discount, only for affiliate-referred shoppers.

   Why: CourseReferral50 ($50 off Courses) was a Shopify automatic discount,
   so it applied to every shopper. That was fine while the courses were
   hidden; once the courses are visible in the shop it would apply to all.

   How it works now:
     - The discount is a code: COURSEREFERRAL50 (Shopify > Discounts,
       "CourseReferral50 (affiliate code)"; $50 off Courses, one-time
       purchases, combines with other discounts).
     - UpPromote sets its own referral cookies (up_uppromote_aid /
       scaaf_aid) when a shopper arrives through any affiliate link,
       including custom product links.
     - When those cookies are present, this script adds COURSEREFERRAL50 to
       the cart's discount codes, keeping any code UpPromote already applied
       (for example the 5% "Affiliate Referral" code). It only affects course
       items, so it is harmless if the shopper buys something else.
     - Shoppers without an affiliate referral never get the code.
   Loaded from snippets/wwf-head.liquid (CL-068 marker), which sets the code.

   LAUNCH STEP: when this theme goes live, deactivate the automatic discount
   "CourseReferral50" in Shopify > Discounts (otherwise everyone still gets it).
   ========================================================================= */
(function () {
  'use strict';
  var cfg = window.wwfAffiliate || {};
  var CODE = cfg.code || 'COURSEREFERRAL50';
  var COOKIES = cfg.cookies || ['up_uppromote_aid', 'scaaf_aid'];

  function hasReferral() {
    var c = '; ' + document.cookie;
    for (var i = 0; i < COOKIES.length; i++) {
      var m = c.split('; ' + COOKIES[i] + '=');
      if (m.length > 1 && m[1].split(';')[0]) return true;
    }
    return false;
  }

  function apply() {
    if (!hasReferral()) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        var has = codes.some(function (c) { return String(c).toUpperCase() === CODE.toUpperCase(); });
        if (has) return;
        codes.push(CODE);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
      })
      .catch(function () {});
  }

  /* UpPromote may set its cookies a moment after the page loads on the first
     visit, so check now and again shortly after. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  setTimeout(apply, 4000);
})();
